import { useCallback, useMemo } from 'react';

import { BaseNavButton, IBaseNavButtonProps } from '../BaseNavButton';

export const CannyLinkItem = ({
  handleSidebarClose,
  isMobileSideBar,
  item,
}: IBaseNavButtonProps) => {
  const onCannyLinkClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
      if (item.onClick) {
        item.onClick(e);
      }

      if (handleSidebarClose && isMobileSideBar) {
        handleSidebarClose();
      }
    },
    [handleSidebarClose, isMobileSideBar, item],
  );

  const itemProps = useMemo(() => {
    return { ...item, onClick: onCannyLinkClick };
  }, [item, onCannyLinkClick]);

  return (
    <BaseNavButton
      item={itemProps}
      isMobileSideBar={isMobileSideBar}
      handleSidebarClose={handleSidebarClose}
    />
  );
};
